import { IUser } from '@qwealth/qdata';
import { createReducer } from '@reduxjs/toolkit';

import { updateUser, putUsers, removeUser, resetUsers, setLoading, createUser } from '../actions/users';

interface IState {
  initializedUsers: boolean;
  isLoading: boolean;
  users: IUser[];
}

const DEFAULT_STATE: IState = {
  initializedUsers: false,
  isLoading: false,
  users: [],
};

export default createReducer(DEFAULT_STATE, builder => {
  builder.addCase(resetUsers, () => ({ ...DEFAULT_STATE }));
  builder.addCase(removeUser, (state, action) => {
    if (state.users.length === 0) return;
    state.users = state.users.filter(user => action.payload !== user.id);
  });
  builder.addCase(createUser, (state, action) => {
    if (state.users.length === 0) return;
    state.users = [...state.users, action.payload];
  });
  builder.addCase(updateUser, (state, action) => {
    if (state.users.length === 0) return;

    const updatedUser = action.payload;
    const index = state.users.findIndex((item: IUser) => item.id === updatedUser.id);
    if (index === -1) return;
    state.users[index] = updatedUser;
  });
  builder.addCase(putUsers, (state, action) => ({ ...state, users: action.payload, initializedUsers: true }));
  builder.addCase(setLoading, (state, action) => ({ ...state, isLoading: action.payload }));
});
